import moment from "moment";
import React, { useEffect, useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { PiNotepadThin, PiVideoCameraThin } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { formatedDateTimeIntoIst } from "src/utils/formUtils/dateTimeFormate";

type Props = {
  calenadarData: any;
};

const ViewLectureNotes = ({ calenadarData }: Props) => {
  const [activeMonthYear, setActiveMonthYear] = useState<any>();

  const navigate = useNavigate()

  const uniqueMonthsAndYears: any = Array.from(
    new Set(
      calenadarData?.map((item: any) => moment(item.date).format("MMMM YYYY"))
    )
  );
  useEffect(() => { 
    setActiveMonthYear(uniqueMonthsAndYears?.length - 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calenadarData]);

  const handleIncreaseMonthYear = () => {
    if (activeMonthYear === uniqueMonthsAndYears?.length - 1) {
      setActiveMonthYear(activeMonthYear);
    } else {
      setActiveMonthYear(activeMonthYear + 1);
    }
  };
  const handleDecreaseMonthYear = () => {
    if (activeMonthYear === 0) {
      setActiveMonthYear(activeMonthYear);
    } else {
      setActiveMonthYear(activeMonthYear - 1);
    }
  };

  // For Calendar Month
  const filterCalendarData = (data: any[], active: string) => {
    return data?.filter((el: any) => {
      return moment(el?.date)?.format("MM-YYYY") === active;
    });
  };

  return (
    <>
      {calenadarData?.length ? (
        <div>
          <div className="grid grid-cols-5 mt-3">
            <div className="flex justify-between gap-3  p-2 rounded">
              {!(activeMonthYear === 0) ? (
                <span
                  className="bg-slate-200  rounded-full p-1 cursor-pointer text-center"
                  onClick={handleDecreaseMonthYear}
                >
                  <IoIosArrowBack />
                </span>
              ) : (
                <div> </div>
              )}

              <span className="text-black text-[18px] font-medium">
                {uniqueMonthsAndYears?.[activeMonthYear]}{" "}
              </span>
              {!(activeMonthYear === uniqueMonthsAndYears?.length - 1) ? (
                <span
                  className="bg-slate-200  rounded-full p-1 cursor-pointer text-center"
                  onClick={handleIncreaseMonthYear}
                >
                  <IoIosArrowForward />
                </span>
              ) : (
                <div> </div>
              )}
            </div>
          </div>
          <div className="border border-slate-200 grid 2xl:grid-cols-8 xl:grid-cols-6 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 xs:grid-cols-1 gap-4 mt-3 p-3 rounded ">
            {filterCalendarData(
              calenadarData,
              moment(uniqueMonthsAndYears?.[activeMonthYear]).format("MM-YYYY")
            )?.map((el: any, ind: any) => {
              return (
                <div
                  key={ind} 
                  onClick={() => { 
                    navigate(`${el?._id}`)
                    
                  }}
                  className={`border text-center p-1 rounded flex flex-col justify-between w-[210px] h-[150px] cursor-pointer`}
                >
                  <div
                    className=" text-left font-medium bg-slate-200 text-[12px] w-[50px] px-1 rounded"
                    
                  >
                    {formatedDateTimeIntoIst(el?.date, "DD MMM")}
                  </div>
                  <p className="text-[12px] text-left hover:text-orange-600 cursor-pointer line-clamp-3 mt-2">
                    {el?.title}
                  </p>
                  <div className="flex gap-4 items-center mt-8">
                    <div className="flex gap-1 items-center bg-slate-100 px-[6px] py-[2px] rounded">
                      <PiVideoCameraThin />{" "}
                      <span className="text-[11px]">{el?.recording}</span>
                    </div>
                    <div className="flex gap-1 items-center bg-slate-100 px-[6px] py-[2px] rounded">
                      <PiNotepadThin />{" "}
                      <span className="text-[11px]">{el?.note} </span>
                    </div>
                  </div>
                
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div className="flex justify-center items-end h-[300px] text-red-700 text-2xl font-semibold">
          No Data Found
        </div>
      )}
    </>
  );
};

export default ViewLectureNotes;
